<template>
    <div>
        <Modal
            :is-open="showClarificationAddressModal"
            size-modal="deprecated"
            @close="closeModal"
        >
            <template #body>
                <AddressClarification
                    :detailed-delivery-times="detailedDeliveryTimes"
                    :default-address="address"
                    :default-store="nearestStore"
                    :default-available="availableFastDelivery"
                    :callback-check-coords="callbackCheckCoords"
                    :real-price="realPrice"
                    :real-delivery-text="realDeliveryText"
                    :external-checking-stores="externalCheckingStores"
                    @handle-set-data="handleSetData"
                    @handle-close="closeModal"
                    @handle-clarification-apartment="
                        handleClarificationApartment
                    "
                />
            </template>
        </Modal>
    </div>
</template>

<script setup>
    /**
     * Фактически компонент быстрой доставки является инициализацией доставки для товара на странице товара
     * Это превышает ответственность компонента и необходимо переделать.
     */
    import Modal from 'vueCommon/ui/Modal.vue';
    import AddressClarification from 'vueCommon/ui/AddressClarification.vue';
    import { eventBus, http, helpers } from 'globalState/global-state.js';
    import { reactive, ref, onMounted } from 'vue';
    import * as deliveryService from 'desktopeModules/checkout/order/api/deliveryService.js';
    import { computed } from 'vue';
    import * as lastInfoService from 'desktopeModules/checkout/order/api/lastInfoService.js';
    import {
        useFastDeliveryStatus,
        useFastDeliveryCookie,
        DeliveryStatus,
        DELIVERY_TEXTS,
    } from 'vueCommon/composables/delivery/index.ts';

    const showClarificationAddressModal = ref(false);
    const productCode = ref('');
    const availableFastDelivery = ref(false);
    const deliveryListProcess = ref(false);
    const nearestStore = ref(null);
    const defaultDeliveryText = ref('');
    const realDeliveryText = ref('');
    const realPrice = ref('');
    const externalCheckingStores = ref(false);
    const address = reactive({
        city: '',
        settlement: '',
        street: '',
        house: '',
        korp: '',
        build: '',
    });

    const fastDeliveryStatus = useFastDeliveryStatus();
    const { getDeliveryState, setDeliveryState, updateApartment } =
        useFastDeliveryCookie();

    const detailedDeliveryTimes = computed(() => {
        if (deliveryListProcess.value) {
            return '';
        }

        if (!availableFastDelivery.value) {
            return defaultDeliveryText.value;
        }

        return realDeliveryText.value;
    });

    onMounted(() => {
        defaultDeliveryText.value = window.config.user.deliveryDate;

        eventBus.handleFastDeliveryModal.subscribe((payload) => {
            productCode.value = payload.productCode;

            if (payload.text === DELIVERY_TEXTS.FAST_DELIVERY.SELECT_REGION) {
                $.fancybox.open({
                    href: $('.region-popup-link').data('href'),
                    type: 'ajax',
                    width: 'auto',
                });
            } else {
                if (
                    payload.text.trim() ===
                    DELIVERY_TEXTS.FAST_DELIVERY.TOMORROW
                ) {
                    availableFastDelivery.value = false;
                }

                if (
                    payload.text.trim() ===
                    DELIVERY_TEXTS.FAST_DELIVERY.DEFAULT_TIME
                ) {
                    availableFastDelivery.value = true;
                }

                showClarificationAddressModal.value = true;
            }

            address.warehouse ? getAvailableStores() : '';
        });

        const savedState = getDeliveryState();

        if (savedState) {
            Object.assign(address, savedState.address);
            availableFastDelivery.value = savedState.availableFastDelivery;
            nearestStore.value = savedState.nearestStore;
        }

        document
            .querySelectorAll('.delivery-variant--fast a')
            .forEach((link) => {
                link.addEventListener('click', function (e) {
                    e.preventDefault();

                    if (!this?.classList?.contains('available-map')) {
                        return;
                    }

                    eventBus.handleFastDeliveryModal.broadcast({
                        productCode: this.dataset.code,
                        text: this.textContent,
                    });
                });
            });
    });

    const closeModal = () => {
        showClarificationAddressModal.value = false;
    };

    const handleClarificationApartment = (val) => {
        if (!updateApartment(val)) {
            return;
        }

        Object.assign(address, { appart: val });
    };

    const handleSetData = (payload) => {
        if (payload.availableFastDelivery) {
            availableFastDelivery.value = payload.availableFastDelivery;
        }

        if (payload.nearestStore) {
            nearestStore.value = payload.nearestStore;
        }

        Object.assign(address, payload.address);

        setDeliveryState({
            address,
            availableFastDelivery: availableFastDelivery.value,
            nearestStore: nearestStore.value,
        });

        lastInfoService
            .putLastInfo(
                helpers.jsonToFormData({
                    address: {
                        coordinates: address.coordinates,
                        city: address.city,
                        settlement: address.settlement,
                        street: address.street,
                        house: address.house,
                        korp: address.korp,
                        build: address.build,
                        zip: address.zip,
                        appart: address.appart,
                        warehouse: address.warehouse,
                    },
                })
            )
            .then(() => {
                setDefaultDeliveryText();
                loadDeliveryListWarehouse();
            });
    };

    /**
     * Устанавливает тексты в списках товара и деталке
     * @deprecated установкой DOM текстов будет заниматься либо хук или какой-то отдельный хелпер.
     * По сути быстрая доставка может отправить "сообщение" что она недоступна.
     */
    const setDefaultDeliveryText = () => {
        const deliveryTextElementList = document.querySelectorAll(
            '.product-delivery-service a'
        );

        if (!window.config?.user?.hasLocation) {
            deliveryTextElementList.forEach((element) => {
                element.textContent =
                    DELIVERY_TEXTS.FAST_DELIVERY.SELECT_REGION;
            });

            return;
        }

        const deliveryBlocks = document.querySelectorAll(
            '.product-delivery-block'
        );

        deliveryBlocks.forEach((product) => {
            const warehouseBlock = product.querySelector('.show-all-shops');
            const deliveryTextBlock = product.querySelector(
                '.product-delivery-service a'
            );

            if (!deliveryTextBlock) {
                return;
            }

            if (
                !warehouseBlock ||
                !deliveryTextBlock.classList.contains('available-map')
            ) {
                deliveryTextBlock.textContent = defaultDeliveryText.value;
            }
        });
    };

    const callbackCheckCoords = ({ lat, lng }) => {
        return http.xmlUnsafeRequest
            .post('/deliveryapi/api/available/stores/', {
                latitude: lat,
                longitude: lng,
                productCode: productCode.value,
            })
            .catch(() => {
                availableFastDelivery.value = false;
                throw new Error('не удалось получить координаты');
            });
    };

    const getAvailableStores = () => {
        externalCheckingStores.value = true;

        return fastDeliveryStatus
            .checkDeliveryAvailability(address.coordinates, callbackCheckCoords)
            .then(({ store: foundStore }) => {
                if (foundStore) {
                    /** @TODO возможно стоит убрать установку адреса т.к. он уже существует. */
                    handleSetData({
                        address: {
                            ...address.value,
                            warehouse: fastDeliveryStatus.warehouseCode.value,
                        },
                        availableFastDelivery:
                            fastDeliveryStatus.availableDeliveryStatus.value ===
                            DeliveryStatus.AVAILABLE,
                        nearestStore: fastDeliveryStatus.nearestStore.value,
                    });
                    return;
                }
            })
            .finally(() => {
                externalCheckingStores.value = false;
            });
    };

    /** Обычная загрузка доставок, но с кодом магазина, чтобы получить время работы магазина */
    const loadDeliveryListWarehouse = () => {
        realDeliveryText.value = '';
        realPrice.value = '';
        deliveryListProcess.value = true;

        const hasDetailsElement =
            document.querySelector('.price-offer .cart-add') ??
            document.querySelector('.product-offer .cart-add');

        if (!productCode.value && hasDetailsElement) {
            productCode.value = hasDetailsElement.dataset.id;
        }

        deliveryService
            .getDeliveryList({
                good_code: productCode.value,
                main_good_code: productCode.value,
                is_fast: 1,
                only_fast: 1,
                delivery_warehouse: address.warehouse,
            })
            .then(({ data }) => {
                if (data.length === 0) {
                    availableFastDelivery.value = false;
                    setDefaultDeliveryText();
                    return;
                }

                if (!data.error) {
                    const fastDeliveryData = data['fastDelivery'];

                    realDeliveryText.value = fastDeliveryData
                        ? fastDeliveryData?.list[0].deliveryPeriod
                        : DELIVERY_TEXTS.FAST_DELIVERY.DEFAULT_TIME;
                    realPrice.value = fastDeliveryData?.list[0].price;
                    setDefaultDeliveryText();
                }

                if (data.error) {
                    availableFastDelivery.value = false;
                    setDefaultDeliveryText();
                }
            })
            .finally(() => {
                deliveryListProcess.value = false;
            });
    };
</script>

<style lang="less">
    .address-input {
        margin-bottom: 10px;
        position: relative;

        .autocomplete-input--label {
            label {
                top: 15px;
            }

            .form-control {
                height: 48px;
            }

            &.focus {
                .form-control {
                    padding: 20px 12px 6px;
                }

                label {
                    top: 5px;
                    font-size: 11px;
                }
            }
        }
    }

    @media screen and (max-width: 379px) {
        .autocomplete-suggestions {
            bottom: 48px;
            top: auto;
            font-size: 14px;
            border-radius: 8px;
            display: flex;
            flex-direction: column-reverse;
            max-height: 200px;
            overflow: auto;
        }
    }
</style>
